import React from "react";

function BaseEntriesSummary({ data }) {
  return (
    <div className="flex items-center gap-2">
      <p className="text-sm text-gray-600">
        {(data && data.meta?.total) ?? 0} Entries
      </p>
    </div>
  );
}

export default BaseEntriesSummary;
